import { useTranslation } from "react-i18next";

import { TOOLTIP_PLACEMENT } from "components/DesignComponents/Tooltips/types/enums";
import UserAccessGroups from "components/Table/TableItem/CustomValues/UserAccessGroups";

import { AccessGroupProps } from "./types";

const AccessGroup = ({ accessGroups }: AccessGroupProps) => {
    const { t } = useTranslation();

    return (
        <>
            <span>{t("Table##access group")}:</span>

            <span>
                <UserAccessGroups
                    accessGroups={accessGroups}
                    tooltipPlacement={TOOLTIP_PLACEMENT.Top}
                />
            </span>
        </>
    );
};

export default AccessGroup;
